import React from 'react';
import i18n from 'i18next';
import WarningAmberOutlined from '@mui/icons-material/WarningAmberOutlined';

import { Icon } from 'uikit/icons';
import { Loading } from 'uikit/loaders';
import { Tooltip } from 'uikit/tooltips';
import { Typo } from 'uikit/content';
import DefaultImage from '@/exceed/images/defaultImage.svg';
import getDateString from '../helpers/getDateString';

import styles from '../styles/challengeModal.module.scss';

const ChallengeModal = ({
  challenge,
  gamification,
  isLoading,
}) => {
  if (isLoading) {
    return (
      <div className={styles.loader}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.element}>
      <div className={styles.header}>
        <div className={styles.subject}>
          <Typo element="h2" variant="d03">
            {i18n.t('challenge-completed')}
          </Typo>
        </div>
        <div className={styles.title}>
          <Typo element="h3" variant="d07">
            {i18n.t('congratulations')}
          </Typo>
        </div>
        <div className={styles.byline}>
          <Typo
            element="span"
            variant="b03"
            weight="medium"
          >
            {i18n.t('youve-completed-challenge', {
              name: challenge.name,
            })}
          </Typo>
        </div>
      </div>
      <div className={styles.body}>
        <div className={styles.image}>
          {challenge?.challenge_picture?.w550 ? (
            <img
              alt={`${challenge.name}`}
              className={styles.imageSrc}
              src={challenge.challenge_picture.w550}
            />
          ) : (
            <DefaultImage className={styles.imageSrc} />
          )}
        </div>
        <div className={styles.requirements}>
          <Typo
            element="span"
            variant="b02"
            weight="medium"
          >
            {i18n.t('challenge-requirement', {
              amount: challenge.required_courses_count,
              start_date: getDateString(challenge.starts_at),
              end_date: getDateString(challenge.ends_at),
            })}
          </Typo>
        </div>
        {(gamification.is_gold_enabled && challenge.gold_earned !== null) && (
          <div className={styles.gold}>
            <div className={styles.goldItem}>
              <Icon icon="gold" size={18} />
              <Typo
                element="span"
                variant="b02"
                weight="medium"
              >
                {i18n.t('gold-earned', { amount: challenge.gold_earned })}
              </Typo>
              {gamification.has_reached_gold_limit && (
                <div className={styles.caution}>
                  <Tooltip content={i18n.t('youve-reached-the-annual-gold-limit')}>
                    <WarningAmberOutlined sx={{ height: 18, width: 18}} />
                  </Tooltip>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default React.memo(ChallengeModal);
